export default "__VITE_ASSET__C8gEBD5z__"